import nbcCardRedirect from '@/forms/components/shared/nbc-card-redirect';

export default nbcCardRedirect({ storeValueCard: true });
